import { combineReducers } from '@reduxjs/toolkit';
import {
  uiReducer,
  authReducer,
  authPersistReducer,
  systemReducer,
  systemPersistReducer,
  listsReducer,
  ordersReducer,
  CustomersReducer,
  MaterialsReducer,
  WarehousesReducer,
  CarriersReducer,
  ContactReducer,
  ReceiptsReducer,
} from './features';
import { api } from './rtk/api';

const reducers = {
  ui: uiReducer,
  auth: authReducer,
  authPersist: authPersistReducer,
  systemPersist: systemPersistReducer,
  system: systemReducer,
  lists: listsReducer,
  orders: ordersReducer,
  customers: CustomersReducer,
  warehouses: WarehousesReducer,
  carriers: CarriersReducer,
  contacts: ContactReducer,
  receipts: ReceiptsReducer,
  materials: MaterialsReducer,
  [api.reducerPath]: api.reducer,
};

export const rootReducer = combineReducers({ ...reducers });
